<template>
    <div class="event-action">
        <h6 class="event-action__title">Стоимость участия:</h6>

        <div class="event-action__prices">
            <span class="event-action__price" v-html="prices.current"></span>
            <span class="event-action__price-old" v-html="prices.old" v-if="prices.old"></span>
        </div>

        <div class="event-action__btn" :class="{'event-action__btn--active': productInCart}">
            <button class="btn btn-main btn-block"
                :disabled="isLoading || productInCart"
                @click="addToBasket"
            >
                <span v-if="isLoading" class="spinner-border spinner-border-sm" />
                <span v-else>
                    <template v-if="productInCart">Добавлено в корзину</template>
                    <template v-else> В корзину</template>
                </span>
            </button>
        </div>

        <div class="event-action__error" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { EVENT_ADD_TO_CART } from '../../../services/event-bus/event-types';
import { globalErrorHandler } from '../../../services/error-handling';

const { eventBus } = window.specialtyApp;

export default {
    name: 'event-detail-action',

    inject: ['$basketService'],

    data() {
        return {
            quantity: 1,
            isLoading: false,

            error: null,
        };
    },

    props: {
        product: {
            type: Object,
        },
    },

    methods: {
        async addToBasket() {
            this.isLoading = true;
            this.error = null;

            try {
                const { data: { data, message } } = await this.$basketService.addToBasket(
                    this.id,
                );

                if (message) {
                    this.error = message;
                    return;
                }

                eventBus.$emit(EVENT_ADD_TO_CART, {
                    basketData: data,
                    type: 'event',
                    actualItem: this.product,
                });
            } catch (error) {
                globalErrorHandler(error);
            } finally {
                this.isLoading = false;
            }
        },
    },

    computed: {
        prices() {
            const price = this.product.CURRENT_PRICE;
            return {
                current: price?.PRINT_DISCOUNT_VALUE,
                old: price?.PRINT_VALUE !== this.price?.PRINT_DISCOUNT_VALUE ? price?.PRINT_VALUE : null,
            };
        },

        basketRows() {
            return Object.values(this.$basketService.state.basketData?.BASKET?.ITEMS || {});
        },

        productInCart() {
            return this.basketRows.find((basketItem) => `${basketItem.PRODUCT_ID}` === `${this.id}`);
        },

        id() {
            return this.product.ID;
        },
    },
};
</script>
